import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import installGridLayouts from "./helper/gridLayoutGlobal";
import { installActivityTracking } from "./helper/activityLog";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import { NetworkProvider, useNetwork } from "./context/NetworkContext";
import { setupInterceptors } from "./apis/axiosInstance";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
// every grid of the app: column order, widths and shown columns kept per user on the server (helper/gridLayoutGlobal.js)
installGridLayouts();
// User Activity Log: every file download and print of every menu (helper/activityLog.js)
installActivityTracking();
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

const root = ReactDOM.createRoot(document.getElementById("root"));
const AppRoot = () => {
  const { setIsNetworkError } = useNetwork();
  useEffect(() => {
    setupInterceptors(setIsNetworkError);
  }, []);
  return <App />;
};
root.render(
  <NetworkProvider>
    <BrowserRouter basename={baseUrl}>
      {/* <App /> */}
      <AppRoot />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        style={{ width: "250px" }}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  </NetworkProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
